import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { EditContractPageRoutingModule } from './edit-contract-routing.module';

import { EditContractPage } from './edit-contract.page';
import {FilePickerComponent} from "../components/file-picker/file-picker.component";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        IonicModule,
        EditContractPageRoutingModule,
    ],
    exports: [
        FilePickerComponent,
    ],
    declarations: [EditContractPage, FilePickerComponent],
})
export class EditContractPageModule {}
